<template>
  <div class="px-2">
    <hr />
  </div>
</template>

<script>
export default {
  name: 'ItemSeparator',
};
</script>

<style scoped>
</style>
